<template>
  <div id="courseInfo">
    <div class="top-title">
      <div class="flex-column-t">
        <p class="course-title">{{ courseInfo.title }}</p>
        <p class="course-info">
          {{ courseInfo.course_type_name }}
          <Divider type="vertical" />
          {{ courseInfo.chapter_num }}章节 | {{ courseInfo.section_num }}课时
          <Divider type="vertical" />
          {{ courseInfo.sales_num }}人学习
        </p>
      </div>
    </div>
    <!-- <Tabs class="tabs">
      <TabPane label="课程大纲">
        <p class="chapter-top">
          章节名称
          <span style="float:right">操作</span>
        </p>
        <Tree v-if="chapters.length > 0" :data="chapters" :render="renderContent"></Tree>
        <div class="bottom">
          <Button @click="createChapter" style="width:300px" icon="ios-add" long>新增章节</Button>
        </div>
      </TabPane>
    </Tabs> -->
    <TreeView :columns="columns" :items="chapters">
      <template slot-scope="{ item, level }" slot="c1">
        <span>{{ item.name }}</span>
        <span
          v-if="level == 0"
          style="font-size: 12px; color: rgb(204, 204, 204); margin-left: 5px"
          >(含{{ item.section_num }}个课时)</span
        >
      </template>
      <template slot-scope="{ item, level }" slot="c2">
        <span>{{ level == 0 ? "章节序号" : "课时序号" }}：</span>
        <span>{{ item.sort }}</span>
      </template>
      <template slot-scope="{ item, level }" slot="cloud_class_type">
        <template v-if="level === 1">
          <span>{{ getCloudClassTypeName(item.cloud_class_type) }}</span>
        </template>
      </template>

      <template slot-scope="{ item, level }" slot="c3">
        <template v-if="level == 1">
          <span>{{ item.start_play | tsFormat("MM月dd日 hh:mm") }}</span>
          <span style="margin: 0 5px">-</span>
          <span>{{ item.end_play | tsFormat("MM月dd日 hh:mm") }}</span>
        </template>
      </template>
      <template slot-scope="{ item, level }" slot="action">
        <div class="action">
          <Button
            @click="appendChapter(item)"
            type="text"
            size="small"
            v-if="level == 0"
            >新增课时-</Button
          >
          <!-- <Button
              @click="onStatistics(item)"
              type="text"
              size="small"
              v-if="level == 1&&(courseInfo.course_type==2||courseInfo.course_type==3)"
            >直播统计-</Button> -->
          <Button @click="changeChapterSort(item)" type="text" size="small"
            >{{ level == 0 ? "章节" : "课时" }}排序-</Button
          >
          <Button @click="editChapter(item)" type="text" size="small"
            >编辑-</Button
          >
          <!-- <Dropdown transfer v-if="level==1">
              <Button type="text" size="small">更多</Button>
              <DropdownMenu slot="list">
                <DropdownItem>
                  <Button @click="removeChapter(item)" type="text" size="small">删除</Button>
                </DropdownItem>
                <DropdownItem v-if="item.teacher_code||item.admin_code||item.student_code">
                  <Button @click="shareJoinCode(item)" type="text" size="small">分享参加吗</Button>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown> -->
          <Button @click="removeChapter(item)" type="text" size="small"
            >删除</Button
          >
        </div>
      </template>
    </TreeView>
    <div class="bottom">
      <Button @click="createChapter" style="width: 300px" icon="ios-add" long
        >新增章节</Button
      >
    </div>
    <Modal
      id="modal"
      v-model="showChapterModal"
      :title="!chapterInfo.id ? '新增章节' : '编辑章节'"
      ref="modal"
    >
      <Form
        ref="chapterForm"
        :rules="ruleValidate"
        :model="chapterInfo"
        :label-width="80"
      >
        <FormItem label="章节名称" prop="title">
          <Input
            style="width: 300px"
            type="text"
            v-model="chapterInfo.title"
            @keydown.native.enter.prevent="inputEnter"
            :maxlength="20"
            placeholder="章节名称最多可输入20个字"
            :disabled="loading"
          />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="showChapterModal = false">取消</Button>
        <Button type="primary" @click="saveChapter">确定</Button>
      </div>
    </Modal>
    <Modal
      class="modal-sort"
      v-model="showChapterSortModal"
      title="排序"
      footer-hide
    >
      <span>
        {{
          sortType == 1 ? "将章节序号设置为" : "将课时在本章节内的序号设置为"
        }}
      </span>
      <InputNumber :min="0" :precision="0" v-model="chapterSort"></InputNumber>
      <Button
        type="primary"
        @click="confirmSortChapter"
        style="margin-left: 50px"
        >保存</Button
      >
    </Modal>
  </div>
</template>
<script>
import * as enums from "../../utils/enums";
import TreeView from "@/components/TreeView.vue";

export default {
  name: "CoursePlan",
  components: { TreeView },
  data() {
    return {
      courseInfo: {},
      chapters: [],
      expand: true,
      showChapterModal: false,
      modalText: "新增章节",
      chapterInfo: {
        id: "",
        title: "",
        sort: 0,
      },
      loading: false,
      ruleValidate: {
        title: [
          { required: true, message: "章节名称必须填写", trigger: "blur" },
        ],
      },
      columns: [
        {
          title: "章节名称",
          slot: "c1",
        },
        {
          title: "云课堂类型",
          slot: "cloud_class_type",
        },

        {
          title: "序号",
          slot: "c2",
          width: 160,
          align: "center",
        },
        {
          title: "操作",
          slot: "action",
          width: 160,
        },
      ],
      render: (h, { root, node, data }) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              fontSize: "14px",
              borderBottom: "1px solid rgb(220, 222, 226)",
            },
          },
          [
            h("span", [
              h("Icon", {
                props: {
                  type: "ios-folder-outline",
                },
                style: {
                  marginRight: "8px",
                },
              }),
              h("span", data.name),
              h("span", {
                style: {
                  fontSize: "12px",
                  color: "#ccc",
                  marginLeft: "5px",
                },
                domProps: {
                  innerText: `(含${
                    data.children ? data.children.length : 0
                  }个课时)`,
                },
              }),
            ]),
            h(
              "span",
              {
                style: {
                  display: "inline-block",
                  float: "right",
                  marginRight: "32px",
                },
              },
              [
                h("Button", {
                  props: {
                    type: "text",
                  },
                  domProps: {
                    innerText: "新增课时",
                  },
                  style: {
                    color: "#2d8cf0",
                  },
                  on: {
                    click: () => {
                      this.appendChapter(data);
                    },
                  },
                }),
                h("span", " - "),
                h("Button", {
                  props: {
                    type: "text",
                  },
                  domProps: {
                    innerText: "编辑",
                  },
                  style: {
                    color: "#2d8cf0",
                  },
                  on: {
                    click: () => {
                      this.editChapter(root, node, data);
                    },
                  },
                }),
                h("span", " - "),
                h("Button", {
                  props: {
                    type: "text",
                  },
                  domProps: {
                    innerText: "删除",
                  },
                  style: {
                    color: "#2d8cf0",
                  },
                  on: {
                    click: () => {
                      this.removeChapter(root, node, data);
                    },
                  },
                }),
              ]
            ),
          ]
        );
      },
      sortType: 1,
      showChapterSortModal: false,
      chapterSort: 0,
    };
  },
  async created() {
    await this.getChapters();
  },
  methods: {
    getCloudClassTypeName(cloudClassType) {
      if (cloudClassType === "plaso") {
        return "伯索云";
      }

      return "百家云";
    },
    async getChapters() {
      let data = await this.$http.get(
        "/api/course/chapter/" + this.$route.query.id
      );
      data.course.course_type_name = enums.CouseType.getValue(
        data.course.course_type
      );
      this.courseInfo = data.course;
      let chapters = data.chapter;
      chapters.forEach((c) => {
        c.render = this.render;
      });
      chapters.forEach((i) => {
        // i.expand = this.expand;
        i._expanded = i.children && i.children.length > 0;
      });
      this.chapters = chapters;
    },
    createChapter() {
      this.chapterInfo.id = "";
      this.chapterInfo.title = "";
      this.chapterInfo.sort = 0;
      this.showChapterModal = true;
    },
    appendChapter(data) {
      this.$router.push({
        name: "CourseChapter",
        query: {
          course_id: this.$route.query.id,
          course_type: this.courseInfo.course_type,
          parent_id: data.id,
        },
      });
    },
    inputEnter() {
      this.saveChapter();
    },
    changeChapterSort(data) {
      this.sortType = data.parent_id == 0 ? 1 : 2;
      this.chapterInfo.id = data.id;
      this.chapterSort = data.sort;
      this.showChapterSortModal = true;
    },
    async confirmSortChapter() {
      await this.$http.get(
        "/api/course/chapter/sort/" +
          this.chapterInfo.id +
          "/" +
          this.chapterSort
      );
      this.showChapterSortModal = false;
      this.$Message.saveSuccess();
      await this.getChapters();
    },
    saveChapter() {
      this.$refs.chapterForm.validate(async (valid) => {
        if (!valid) {
          return;
        }
        this.loading = true;
        let data = {};
        data.title = this.chapterInfo.title;
        data.course_basis_id = this.$route.query.id;
        data.parent_id = 0;
        data.course_type = this.courseInfo.course_type;
        data.cloud_class_type = "";
        data.sort = this.chapterInfo.sort;
        if (this.chapterInfo.id) {
          data.id = this.chapterInfo.id;
        }
        try {
          if (!data.id) {
            await this.$http.post("/api/course/chapter", data);
          } else {
            await this.$http.put("/api/course/chapter", data);
          }
        } finally {
          this.loading = false;
        }
        this.showChapterModal = false;
        this.$Message.saveSuccess();
        await this.getChapters();
      });
    },
    editChapter(data) {
      if (data.parent_id > 0) {
        this.$router.push({
          name: "CourseChapter",
          query: {
            course_id: this.$route.query.id,
            course_type: this.courseInfo.course_type,
            parent_id: data.parent_id,
            id: data.id,
          },
        });
        return;
      }
      this.chapterInfo.id = data.id;
      this.chapterInfo.title = data.name;
      this.chapterInfo.sort = data.sort;
      this.showChapterModal = true;
    },
    removeChapter(data) {
      if (data.hasOwnProperty("children") && data.children.length > 0) {
        this.$Modal.warning({
          title: "提示",
          content: "<p>当前章节下含有课时内容，无法删除</p>",
        });
        return;
      }
      if (data.parent_id == 0) {
        this.$Modal.confirm({
          title: "提示",
          content: "确认要删除该章节吗？",
          onOk: async () => {
            await this.$http.delete("/api/course/chapter/" + data.id);
            this.$Message.deleteSuccess();
            this.getChapters();
          },
        });
      } else {
        this.$Modal.confirm({
          title: "提示",
          content: "删除后，员工将无法学习此课时，是否确认？",
          onOk: async () => {
            await this.$http.delete("/api/course/chapter/" + data.id);
            this.$Message.deleteSuccess();
            this.getChapters();
          },
        });
      }
    },
    renderContent(h, { root, node, data }) {
      return h(
        "span",
        {
          style: {
            display: "inline-block",
            width: "100%",
          },
        },
        [
          h("span", [
            h("Icon", {
              props: {
                type: "ios-paper-outline",
              },
              style: {
                marginRight: "8px",
              },
            }),
            h("span", data.name),
          ]),
          h(
            "span",
            {
              style: {
                display: "inline-block",
                float: "right",
                marginRight: "32px",
              },
            },
            [
              h("Button", {
                props: {
                  type: "text",
                },
                style: {
                  color: "#2d8cf0",
                },
                domProps: {
                  innerText: "编辑",
                },
                on: {
                  click: () => {
                    this.editChapter(root, node, data);
                  },
                },
              }),
              h("span", " - "),
              h("Button", {
                props: {
                  type: "text",
                },
                style: {
                  color: "#2d8cf0",
                },
                domProps: {
                  innerText: "删除",
                },
                on: {
                  click: () => {
                    this.removeChapter(root, node, data);
                  },
                },
              }),
            ]
          ),
        ]
      );
    },
  },
};
</script>
<style lang="scss" scoped>
#courseInfo {
  padding: 15px;
  background-color: #fff;
  height: calc(100vh - 130px);
  .top-title {
    padding: 15px;
    border: 1px solid #eee;
    .flex-t-l {
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      img {
        float: left;
        width: 210px;
        height: 160px;
        margin-right: 15px;
        vertical-align: middle;
        flex-shrink: 0;
        object-fit: cover;
      }
      .flex-column-t {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }
    }
    .course-title {
      font-size: 16px;
      color: #333;
      margin-bottom: 10px;
    }
    .course-info {
      font-size: 13px;
      margin-bottom: 10px;
    }
    .course-indu {
      font-size: 13px;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
  .tabs {
    margin-top: 10px;
    .chapter-top {
      padding: 0 15px;
      height: 40px;
      line-height: 40px;
      font-size: 14px;
      background: rgb(241, 241, 241);
    }
  }
  .bottom {
    margin-top: 20px;
    text-align: center;
  }
}
</style>
